<template>
  <div
    ref="chartRef"
    style="width: 100%; height: 260px"
  ></div>
</template>

<style scoped>
</style>

<script>
import * as echarts from 'echarts';
import { chartSelectList } from '../index';
export default {
  name: 'EchartCon',
  props: {
    chartType: {
      type: String,
      default: 'line',
      validator: (value) => ['line', 'bar'].includes(value),
    },
    data: {
      type: Array,
      default: () => [],
    },
    yAxisField: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      chart: null,
      chartSelectList,
    };
  },
  watch: {
    data: {
      handler() {
        this.renderChart();
      },
      deep: true,
    },
    chartType() {
      this.renderChart();
    },

    yAxisField: {
      handler() {
        this.renderChart();
      },
      deep: true,
    },
  },
  mounted() {
    this.initChart();
    window.addEventListener('resize', this.handleResize);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize);
    if (this.chart) {
      this.chart.dispose();
    }
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$refs.chartRef);
      this.renderChart();
    },
    renderChart() {
      if (!this.chart) return;

      const hasData = this.data && this.data.length > 0;
      const dates = hasData ? this.data.map((item) => item.date) : [];
      const data1 = hasData ? this.data.map((item) => item[this.yAxisField[0]]) : [];
      const data2 = hasData ? this.data.map((item) => item[this.yAxisField[1]]) : [];

      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
          },
        },
        legend: {
          data: [
            this.chartSelectList.find((v) => v.id == this.yAxisField[0]).name,
            this.chartSelectList.find((v) => v.id == this.yAxisField[1]).name,
          ],
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          data: dates,
          axisPointer: {
            type: 'shadow',
          },
        },
        yAxis: [
          {
            type: 'value',
            name: this.chartSelectList.find((v) => v.id == this.yAxisField[0]).name,
            position: 'left',
            axisLine: { show: false },
          },
          {
            type: 'value',
            name: this.chartSelectList.find((v) => v.id == this.yAxisField[1]).name,
            position: 'right',
            axisLine: { show: false },
          },
        ],
        series: [
          {
            name: this.chartSelectList.find((v) => v.id == this.yAxisField[0]).name,
            type: this.chartType,
            data: data1,
            yAxisIndex: 0,
            itemStyle: {
              color: '#d81e06'
            }
          },
          {
            name: this.chartSelectList.find((v) => v.id == this.yAxisField[1]).name,
            type: this.chartType,
            data: data2,
            yAxisIndex: 1,
            itemStyle: {
              color: '#1296db'
            }
          },
        ],
      };

      this.chart.setOption(option);
    },
    handleResize() {
      if (this.chart) {
        this.chart.resize();
      }
    },
  },
};
</script>
